import React from 'react';
import Headline from 'common/components/TouchpointEditor/components/TouchpointNodes/Headline/SubTypes/EventTitleHeadline/EventTitleHeadline';

export default function EventTitleHeadline(props) {
    return <Headline {...props} />;
}

EventTitleHeadline.splash = {
    ...Headline.splash,
    defaultProps: {
        ...Headline.splash.defaultProps,
        styles: {
            ...Headline.splash.defaultProps.styles,
            fontSize: 60,
        },
    },
};
